import TimerSVG from './timer_svg';
import {useSelector} from 'react-redux';
import Selector from '../../../../selectors/pages/halloween';
import Timer from '../timer';

export default () => {
    const {halloween} = useSelector(Selector);

    return (
        <div className="main_prize">
            <div className="title">Main prize</div>
            <div className="details">
                <div className="amount">$5.000</div>
                <div className="amount">$5.000</div>
                <div className="timer">
                    <div className="text">Before the drawing</div>
                    <div className="time">
                        <div className="content">
                            <Timer timeoutKey={"main-prize-halloween"} timestamp={halloween.timestamp} />
                        </div>
                        <TimerSVG />
                    </div>
                </div>
            </div>
        </div>
    )
}